<div class="team-setup">
  <!-- Header -->
  <div class="setup-header">
    <button class="back-btn" (click)="goBack()">
      <span class="back-arrow">&#8592;</span>
    </button>
    <span class="setup-title">{{ currLang === 'ar' ? 'إعداد الفرق' : 'Team Setup' }}</span>
    <button class="randomize-btn" (click)="randomizeTeams()">
      {{ currLang === 'ar' ? 'عشوائي' : 'Randomize' }}
    </button>
  </div>

  <div class="setup-body">
    <!-- Team A (Blue) -->
    <div class="team-panel team-a">
      <div class="team-color-bar"></div>
      <div class="team-name-input">
        <input type="text"
               [value]="teamANameInput"
               (input)="onTeamANameChange($any($event.target).value)"
               [placeholder]="currLang === 'ar' ? 'اسم الفريق' : 'Team name'"
               maxlength="20" />
      </div>
      <div class="team-count">{{ teamAStudents.length | arabicNumber:currLang }} {{ currLang === 'ar' ? 'طالب' : 'students' }}</div>
      <div class="team-drop-zone"
           cdkDropList
           [cdkDropListData]="teamAStudents"
           [cdkDropListConnectedTo]="[studentPool, teamBList]"
           #teamAList="cdkDropList"
           (cdkDropListDropped)="drop($event)">
        <div class="drop-placeholder" *ngIf="teamAStudents.length === 0">
          {{ currLang === 'ar' ? 'اسحب الطلاب هنا' : 'Drag students here' }}
        </div>
        <div class="student-chip" *ngFor="let student of teamAStudents" cdkDrag>
          <div class="drag-preview" *cdkDragPreview>
            <app-student-avatar [student]="student" [size]="36"></app-student-avatar>
            <span>{{ getStudentName(student) }}</span>
          </div>
          <app-student-avatar [student]="student" [size]="32"></app-student-avatar>
          <span class="student-name">{{ getStudentName(student) }}</span>
        </div>
      </div>
    </div>

    <!-- Available Students Pool -->
    <div class="student-pool-panel">
      <div class="pool-title">{{ currLang === 'ar' ? 'الطلاب' : 'Students' }}</div>
      <div class="pool-count">{{ availableStudents.length | arabicNumber:currLang }} {{ currLang === 'ar' ? 'متاح' : 'available' }}</div>
      <div class="student-pool"
           cdkDropList
           [cdkDropListData]="availableStudents"
           [cdkDropListConnectedTo]="[teamAList, teamBList]"
           #studentPool="cdkDropList"
           (cdkDropListDropped)="drop($event)">
        <div class="pool-empty" *ngIf="availableStudents.length === 0">
          {{ currLang === 'ar' ? 'تم توزيع جميع الطلاب' : 'All students assigned' }}
        </div>
        <div class="student-chip pool-chip" *ngFor="let student of availableStudents" cdkDrag>
          <div class="drag-preview" *cdkDragPreview>
            <app-student-avatar [student]="student" [size]="36"></app-student-avatar>
            <span>{{ getStudentName(student) }}</span>
          </div>
          <app-student-avatar [student]="student" [size]="32"></app-student-avatar>
          <span class="student-name">{{ getStudentName(student) }}</span>
        </div>
      </div>
    </div>

    <!-- Team B (Red) -->
    <div class="team-panel team-b">
      <div class="team-color-bar"></div>
      <div class="team-name-input">
        <input type="text"
               [value]="teamBNameInput"
               (input)="onTeamBNameChange($any($event.target).value)"
               [placeholder]="currLang === 'ar' ? 'اسم الفريق' : 'Team name'"
               maxlength="20" />
      </div>
      <div class="team-count">{{ teamBStudents.length | arabicNumber:currLang }} {{ currLang === 'ar' ? 'طالب' : 'students' }}</div>
      <div class="team-drop-zone"
           cdkDropList
           [cdkDropListData]="teamBStudents"
           [cdkDropListConnectedTo]="[studentPool, teamAList]"
           #teamBList="cdkDropList"
           (cdkDropListDropped)="drop($event)">
        <div class="drop-placeholder" *ngIf="teamBStudents.length === 0">
          {{ currLang === 'ar' ? 'اسحب الطلاب هنا' : 'Drag students here' }}
        </div>
        <div class="student-chip" *ngFor="let student of teamBStudents" cdkDrag>
          <div class="drag-preview" *cdkDragPreview>
            <app-student-avatar [student]="student" [size]="36"></app-student-avatar>
            <span>{{ getStudentName(student) }}</span>
          </div>
          <app-student-avatar [student]="student" [size]="32"></app-student-avatar>
          <span class="student-name">{{ getStudentName(student) }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Finalize Button -->
  <div class="setup-footer">
    <button class="finalize-btn" [class.ready]="canFinalize()" [disabled]="!canFinalize()" (click)="finalizeTeams()">
      {{ currLang === 'ar' ? 'ابدأ اللعبة!' : 'Start Game!' }}
    </button>
    <div class="finalize-hint" *ngIf="!canFinalize()">
      {{ currLang === 'ar' ? 'أضف طالبًا واحدًا على الأقل لكل فريق' : 'Add at least 1 student to each team' }}
    </div>
  </div>
</div>
